import { render } from "./ProjectImage.vue?vue&type=template&id=38d236e0&scoped=true&lang=pug"
import script from "./ProjectImage.vue?vue&type=script&lang=js"
export * from "./ProjectImage.vue?vue&type=script&lang=js"

import "./ProjectImage.vue?vue&type=style&index=0&id=38d236e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d236e0"]])

export default __exports__